import module from 'viaticos/module.js'

export class ViaticosViaticoDevolucionesAgregarService {
  constructor ($http, $api) {
    this.$http = $http
    this.$api = $api
  }

  get (folio, indice, extension, formato) {
    return formato === 'get' ? this.$http.get('/api/viaticos/viaticos/viatico/documentos', {
      params: {
        folio: folio,
        indice: indice,
        formato: formato,
        extension: extension,
      },
    }) : this.$api.link('/api/viaticos/viaticos/viatico/documentos', {
      folio: folio,
      indice: indice,
      formato: formato,
      extension: extension,
      textrandom: this.makeid(),
    })
  }

  post (folio, indice, file, extension) {
    let data = new FormData()
    data.append('archivo', file)
    return this.$http.post('/api/viaticos/viaticos/viatico/documentos', data, {
      params: {
        folio: folio,
        indice: indice,
        extension: extension,
      },
    })
  }

  delete (folio, indice, file, extension) {
    return this.$http.delete('/api/viaticos/viaticos/viatico/documentos', {
      params: {
        folio: folio,
        indice: indice,
        extension: extension,
      },
    })
  }

  makeid () {
    let text = ''
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    {
      for (let i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
    }
    return text
  }
}

module.service('ViaticosViaticoDevolucionesAgregarService', ViaticosViaticoDevolucionesAgregarService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Viatico/Devoluciones/Agregar/Documentos.js